import {ModalWindow} from "./modalWindow.js";
import {NumberSelect} from "../numberSelect.js";

export class ModalEditAbsence extends ModalWindow {

   constructor(title, maxHours, value, note, callback) {
      super();

      this.panel.classList.add('dark-transparent');

      this.elMain = HTMLElement.createFromHTML(
         '<div class="modal-edit-absence">'
       + '   <div class="container">'
       + '      <div class="title">' + title + '</div>'
       + '      <div class="label-note">Bemerkung</div>'
       + '      <input type="text" class="note"></input>'
       + '      <div class="label-cnt-hours">Anzahl der an diesem Termin versäumten Stunden</div>'
       + '      <div class="cnt-hours"></div>'
       + '      <div class="buttons">'
       + '         <div class="btn-cancel button-circle"><i class="icon-cross"></i></div>'
       + '         <div class="btn-ok button-circle"><i class="icon-check"></i></div>'
       + '      </div>'
       + '   </div>'
       + '</div>'
      );

      // Stunde
      this.hourCnt = new NumberSelect({onChange: () => {}, getNumberTitle: (i) => i, max: maxHours+1, columns: 6, selectRange: false });
      this.hourCnt.setSelection(value);
      this.elMain.querySelector('.cnt-hours').appendChild(this.hourCnt.getElement());

      this.panel.append(this.elMain);
      let elNote = this.elMain.querySelector('.note');
      elNote.focus();
      elNote.value = note;

      this.elMain.querySelector('.btn-ok').onclick = () => {
         callback(this.hourCnt.getSelection(), elNote.value);
         this.close();
      };

      this.elMain.querySelector('.btn-cancel').onclick = () => {
         this.close();
      };

      setTimeout(() => this.show(), 1);

   }
}
